import { api } from '../core';
import { BUNDLE_PAGE_FIND_MISSING_TAG } from '../constants';
import { RootState, setBundleRetrievePageIds } from '@/store';

type BundleFindMissingResponse = string[];

type BundleFindMissingProps = {
  pageId: string;
  windowSize: number;
};

export const getBundlePageFindMissingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundlePageFindMissing: builder.query<BundleFindMissingResponse, BundleFindMissingProps>({
      query: ({ pageId, windowSize }: BundleFindMissingProps) => {
        return {
          url: `bundle/find-missing`,
          method: 'GET',
          params: {
            pageId: pageId,
            windowSize: windowSize
          }
        };
      },
      providesTags: (_result, _err, { pageId, windowSize }) => [
        {
          type: BUNDLE_PAGE_FIND_MISSING_TAG,
          id: pageId,
          windowSize: windowSize
        }
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;
          const resolvedBundleKey = state.sharedData.activeBundleType;

          if (resolvedBundleKey && data && Array.isArray(data)) {
            dispatch(
              setBundleRetrievePageIds({
                key: resolvedBundleKey,
                data: data
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundlePageFindMissing in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundlePageFindMissingQuery } = getBundlePageFindMissingApi;
